import $ from "jquery/dist/jquery";

$(() => {
  function toggleFav(e) {
    const itemPk = e.attr("data-item-pk");
    const turnOn = !e.hasClass("fav-on");
    const favTextTarget = $(e.attr("data-fav-text-target"));

    $.ajax({
      method: "post",
      url: window.NXURLS.URL_ESHOP_ITEM_FAV_API,
      data: {
        action: turnOn ? "add" : "delete",
        pk: itemPk,
      },
    }).done(() => {
      e.removeClass("fav-on")
        .removeClass("fav-off")
        .addClass(turnOn ? "fav-on" : "fav-off");
      if (turnOn) {
        favTextTarget.html(e.attr("data-fav-on-text"));
      } else {
        favTextTarget.html(e.attr("data-fav-off-text"));
      }
    });
  }

  if (window.NXMOD.ESHOP_ITEM_FAVS) {
    $(document).on("click", ".fav-toggle", function (e) {
      e.preventDefault();
      toggleFav($(this));
    });
  }
});
